import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import CommunityServiceTracker from './CommunityServiceTracker';
import CommunityServiceReports from './CommunityServiceReports';
import CommunityServiceAdmin from './CommunityServiceAdmin';

const CommunityServiceDashboard = ({ user, userType, db, isAdmin }) => {
    const [activeTab, setActiveTab] = useState('tracker');
    const [isCommunityServiceAdmin, setIsCommunityServiceAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkCommunityServiceAdminStatus();
    }, [user]);

    const checkCommunityServiceAdminStatus = async () => {
        if (!user) {
            setLoading(false);
            return;
        }

        try {
            const adminDoc = await getDoc(doc(db, 'communityServiceAdmins', user.email));
            if (adminDoc.exists() && !adminDoc.data().removed) {
                setIsCommunityServiceAdmin(true);
            } else {
                setIsCommunityServiceAdmin(false);
            }
        } catch (error) {
            console.error('Error checking community service admin status:', error);
            setIsCommunityServiceAdmin(false);
        }
        setLoading(false);
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-lg text-gray-600">Loading community service...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Tab Navigation */}
            <div className="bg-white shadow-sm border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6">
                    <nav className="flex space-x-8">
                        <button
                            onClick={() => setActiveTab('tracker')}
                            className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                                activeTab === 'tracker'
                                    ? 'border-[#782953] text-[#782953]'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                        >
                            Log Hours
                        </button>
                        <button
                            onClick={() => setActiveTab('reports')}
                            className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                                activeTab === 'reports'
                                    ? 'border-[#782953] text-[#782953]'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                        >
                            Reports
                        </button>
                        {isAdmin && (
                            <button
                                onClick={() => setActiveTab('admin')}
                                className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                                    activeTab === 'admin'
                                        ? 'border-[#782953] text-[#782953]'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                            >
                                Administration
                            </button>
                        )}
                    </nav>
                </div>
            </div>

            {/* Tab Content */}
            <div className="py-6">
                {activeTab === 'tracker' && (
                    <CommunityServiceTracker
                        user={user}
                        userType={userType}
                        db={db}
                        isAdmin={isAdmin}
                        isCommunityServiceAdmin={isCommunityServiceAdmin}
                    />
                )}
                {activeTab === 'reports' && (
                    <CommunityServiceReports
                        user={user}
                        userType={userType}
                        db={db}
                        isAdmin={isAdmin}
                        isCommunityServiceAdmin={isCommunityServiceAdmin}
                    />
                )}
                {activeTab === 'admin' && isAdmin && (
                    <CommunityServiceAdmin
                        user={user}
                        userType={userType}
                        db={db}
                        isAdmin={isAdmin}
                    />
                )}
            </div>
        </div>
    );
};

export default CommunityServiceDashboard;
